import vitalicLogoUrl from '@/assets/vitalic-logo.svg';
import { track } from '@/lib/analytics';
import { useFunnelStore } from '@/store/useFunnelStore';

interface Props {
  /**
   * Only the canvas route has a scenario, and only a scenario has a history.
   * Omitted elsewhere, which hides the button rather than showing one that
   * opens an empty panel.
   */
  showHistory?: boolean;
}

/** Persistent Vitalic brand bar shared by every route in the demo. */
export function BrandNavbar({ showHistory = false }: Props) {
  const openHistory = useFunnelStore((s) => s.openHistory);

  return (
    <header className="app-navbar">
      <img
        className="app-navbar__logo"
        src={vitalicLogoUrl}
        width="176"
        height="45"
        alt="Vitalic"
      />

      {/* History is scenario-scoped, not stage-scoped, so it belongs in the
          persistent chrome rather than behind one of the drawer's stage tabs. */}
      {showHistory && (
        <button
          type="button"
          className="app-navbar__history"
          onClick={() => {
            track('history_opened');
            openHistory();
          }}
        >
          History
        </button>
      )}
    </header>
  );
}
